/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './editJoinLink.defs.js'
export { main as default } from './editJoinLink.defs.js'
